import React from "react"
import strings from "../../../localization/strings"
import DoubleField from "../../common/DoubleField"
import { patchAccount, patchSpecificAccount } from "../../../actions/AccountActions"
import _ from "lodash"
import { IAccountDocument } from "../../../models"
interface IProps {
    accountManager: boolean
    account: IAccountDocument
    readOnly?: boolean
    updateLoadedAccount?(account: IAccountDocument): Promise<IAccountDocument>
}
interface IState {
    perEmployeePerMonthRate: string
}

export default class AccountPerEmployeePerMonthRate extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            perEmployeePerMonthRate: props.account.BillingInfo.PerEmployeePerMonthRate.toString()
        }
    }

    savePerEmployeePerMonthRate = _.debounce(() => {
        this.handleUpdateAccount({ BillingInfo: { PerEmployeePerMonthRate: Number(this.state.perEmployeePerMonthRate) } })
    }, 1500)

    handleUpdateAccount(account, cb = null) {
        this.props.accountManager ?
            patchSpecificAccount(this.props.account.Id, account, this.props.account.TicksSinceChange,
                res => this.props.updateLoadedAccount(res.data as IAccountDocument).then(() => {
                    cb && cb()
                })
            ) :
            patchAccount(this.props.account.Id, account, cb)
    }

    render() {
        return (
            <div style={{ flex: 1, display: "flex" }}>
                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                <DoubleField
                    name="PerEmployeePerMonthRate"
                    label={strings.Account_PEPM}
                    value={this.state.perEmployeePerMonthRate}
                    style={this.props.accountManager ? { width: "100%" } : { maxWidth: 275 }}
                    handleChange={(perEmployeePerMonthRate) => {
                        if (perEmployeePerMonthRate.length > 5) return
                        this.setState({ perEmployeePerMonthRate }, () => this.savePerEmployeePerMonthRate())
                    }}
                    readonly={this.props.readOnly}
                />
            </div>
        )
    }
}
